/**
 * This file is the entrypoint of the lib to export all the components
 * that must be available for people that use lyriapay library.
 */
import PspComposer from '@/lib/components/PspComposer';
import React from 'react';
import PayButton from '@/lib/components/PaymentPageButton';
import PropTypes from 'prop-types';
import axios from 'axios';

const NO_OP = () => {};

const LyriaPay = React.forwardRef(
    (
        {
            isPaymentPage = false,
            token,
            lyriaUrl,
            ...rest
        }, ref,
    ) => {
        const App = isPaymentPage ? PayButton : PspComposer;
        const [paymentRequestData, setPaymentRequestData] = React.useState();
        const [isLoading, setIsLoading] = React.useState(true);

        React.useEffect(() => {
            if (token && lyriaUrl) {
                axios({
                    method: 'POST',
                    url: `${lyriaUrl}/payments/paymentrequests`,
                    data: {
                        request_token: token,
                    },
                })
                    .then((paymentRequest) => {
                        setPaymentRequestData(paymentRequest.data);
                        setIsLoading(false);
                    });
            }
        }, [token, lyriaUrl, setIsLoading]);


        return (
            <App
                ref={ref}
                token={token}
                lyriaUrl={lyriaUrl}
                paymentRequestId={paymentRequestData?.id}
                paymentPageURL={paymentRequestData?.payment_page_url}
                isLoading={isLoading}
                env={paymentRequestData?.payment_info?.env}
                successCallbackUrl={paymentRequestData?.payment_info?.success_callback_url}
                failureCallbackUrl={paymentRequestData?.payment_info?.failure_callback_url}
                setDisplayCallbackBlock={NO_OP}
                bankStatement={paymentRequestData?.payment_info?.bank_statement}
                {...rest}
            />
        );
    },
);

LyriaPay.propTypes = {
    isPaymentPage: PropTypes.bool,
    token: PropTypes.string.isRequired,
    lyriaUrl: PropTypes.string.isRequired,
};

export default LyriaPay;
